export const isObject = value =>
  value && typeof value === 'object' && !Array.isArray(value);

export const isSupportingDocument = value =>
  isObject(value) && value.confirmationCode;
